import React from "react";
import { useLocation } from "react-router-dom";
import Navbar2 from "./pages/Home/Navbar2/Navbar2";
import Footer from "./pages/Home/Footer";

const AppLayout = ({ children, userInfo }) => {
  const location = useLocation();

  const scoreboardPublicPrefixes = [
    "/score-public/",
    "/scoreboard-public/",
    "/scoreboard-jjcombat/",
    "/score-public-jjcombat/",
    "/scoreboard-duo/",
    "/score-public-duo/",
    "/scoreboard-newaza/",
  ];

  const isScoreboardPublic = scoreboardPublicPrefixes.some((prefix) =>
    location.pathname.startsWith(prefix),
  );

  return (
    <div className="flex flex-col min-h-screen bg-base-200 dark:bg-gray-600 dark:text-gray-200">
      {!isScoreboardPublic && (
        <Navbar2
          user={{
            nom: userInfo?.nom ?? "Chargement...",
            prenom: userInfo?.prenom ?? "",
            role_id: userInfo?.role_id ?? 0,
            photoURL: userInfo?.photoURL ?? "",
            userId: userInfo?.id ?? 0,
          }}
        />
      )}

      {children}

      {!isScoreboardPublic && <Footer />}
    </div>
  );
};

export default AppLayout;